<template>
<div>
	<detail-nav title="合作设置" @navigateBack="gpNavigateback"></detail-nav>
	<div class="gp-layer-body">
		<div class="gp-section">
			<div class="gp-row">
				<div class="gp-row-label">开启合伙人申请附加条件</div>
				<el-popover width="240" trigger="hover" placement="right-start">
					<div class="tip1">
						<div class="tip-title">应用场景</div>
						<div class="tip-desc">合伙人会根据您设置的条件提交申请内容</div>
						<div class="tip-img">
							<img src="../../assets/img/partner/apply_tip_icon.png?v=1" />
						</div>
					</div>
					<div class="margin-left-5" slot="reference">
						<i class="el-icon-question" style="color: #CCCCCC;"></i>
					</div>
				</el-popover>
				
				<div class="margin-left-113">
					<el-switch v-model="is_extend" active-color="#0486FE" inactive-color="#CCCCCC"
						@change="changeOpen2"></el-switch>
				</div>
			</div>
			<div class="gp-label-tip">
				设置后可根据申请内容判断合伙人是否具备合作条件
			</div>
		</div>
		
		<div class="gp-section padding-top-0 padding-bottom-0">
			<div class="gp-row">
				<div class="gp-option-item">
					<div class="gp-option-block">
						<div class="red_require" :style="checkedTxt ? 'visibility: visible' : ''">*</div>
						<div class="gp-row-label margin-right-12">{{option_txt.info.title}}</div>
						<div class="gp-row-value">
							<el-input class="gp_input"
								v-model="option_txt.value"
								:disabled="!is_extend || !checkedTxt"
								:placeholder="option_txt.info.remark" maxlength="8">
							</el-input>
						</div>
						<label class="el-checkbox" :class="{'is-checked': checkedTxt, 'is-disabled': !is_extend}" style="margin-left: 10px;">
							<span class="el-checkbox__input" :class="{'is-checked': checkedTxt, 'is-disabled': !is_extend}">
								<span class="el-checkbox__inner" @click="changeCheckedTxt"></span>
								<input type="checkbox" aria-hidden="false" class="el-checkbox__original" value="">
							</span>
						</label>
					</div>
					<div class="gp-option-block margin-top-15">
						<div class="red_require" :style="checkedImg ? 'visibility: visible' : ''">*</div>
						<div class="gp-row-label margin-right-12">{{option_img.info.title}}</div>
						<div class="gp-row-value">
							<el-input class="gp_input"
								v-model="option_img.value"
								:disabled="!is_extend || !checkedImg"
								:placeholder="option_img.info.remark" maxlength="8">
							</el-input>
						</div>
						<label class="el-checkbox" :class="{'is-checked': checkedImg, 'is-disabled': !is_extend}" style="margin-left: 10px;">
							<span class="el-checkbox__input" :class="{'is-checked': checkedImg, 'is-disabled': !is_extend}">
								<span class="el-checkbox__inner" @click="changeCheckedImg"></span>
								<input type="checkbox" aria-hidden="false" class="el-checkbox__original" value="">
							</span>
						</label>
					</div>
				</div>
			</div>
		</div>

		<div class="gp-section margin-top-80" v-if="is_extend">
			<el-button type="primary" class="btn-save" @click="setConfig">保存</el-button>
		</div>
	</div>
</div>
</template>

<script>
	import {
		getBrandConfig,
		setBrandConfig
	} from '../../api/partner';
	import detailNav from '@/components/detail-nav.vue';
	export default {
		data() {
			return {
				is_extend: false, //是否开启附加条件
				checkedTxt: false,
				checkedImg: false,
				option_txt: {
					value: '',
					info: {}
				},
				option_img: {
					value: '',
					info: {}
				}
			}
		},
		components: {
			detailNav
		},
		mounted() {
			this.getConfig();
		},
		methods: {
			gpNavigateback() {
				localStorage.setItem('keypage', this.list_page);
				this.$router.go(-1);
			},
			changeOpen2(res) {
				this.is_extend = res;
				if (res) {
					this.checkedTxt = true;
					this.checkedImg = true;
				} else {
					this.checkedTxt = false;
					this.checkedImg = false;
					this.setConfig();
				}
			},
			changeCheckedTxt() {
				if (this.is_extend) {
					if (!this.checkedImg && this.checkedTxt) {
						this.$message.error('至少保留一项');
						return false;
					}
					this.checkedTxt = !this.checkedTxt;
				}
			},
			changeCheckedImg() {
				if (this.is_extend) {
					if (!this.checkedTxt && this.checkedImg) {
						this.$message.error('至少保留一项');
						return false;
					}
					this.checkedImg = !this.checkedImg;
				}
			},
			getConfig() {
				getBrandConfig({}).then(res => {
					if (res.code == 0) {
						this.is_extend = res.data.is_extend ? true : false;
						var resdata = res.data.config_list;
						resdata.forEach((item) => {
							switch (item.name) {
								case 'option_txt':
									this.option_txt.value = item.config_value === null ? '' : item.config_value;
									this.option_txt.info = item;
									this.checkedTxt = item.config_value === null ? false : true;
									break;
								case 'option_img':
									this.option_img.value = item.config_value === null ? '' : item.config_value;
									this.option_img.info = item;
									this.checkedImg = item.config_value === null ? false : true;
									break;
							}
						})
					} else {
						this.$message.error(res.message);
					}
				})
			},
			setConfig() {
				var is_extend = this.is_extend;
				var request_data = {
					is_extend: is_extend ? 1 : 0
				}
				if (is_extend) {
					if (this.checkedTxt) {
						request_data.option_txt = this.option_txt.value.trim()
						if (request_data.option_txt.length == 0) {
							this.$message.error('请填写' + this.option_txt.info.title)
							return false
						}
					}
					if (this.checkedImg) {
						request_data.option_img = this.option_img.value.trim()
						if (request_data.option_img.length == 0) {
							this.$message.error('请填写' + this.option_img.info.title)
							return false
						}
					}
				}

				setBrandConfig(request_data).then(res => {
					if (res.code == 0) {
						this.$message.success('保存成功');
						this.getConfig();
					} else {
						this.$message.error(res.message);
					}
				})
			}
		}
	};
</script>

<style scoped>
	.el-input__inner {
		padding: 0 12px;
	}
	
	.el-checkbox >>> .el-checkbox__inner {
		width: 20px;
		height: 20px;
	}
	
	.el-checkbox >>> .el-checkbox__inner::after {
	    height: 7px;
	    left: 7px;
	    top: 4px;
	}
	
	.el-input.is-disabled >>> .el-input__inner {
		background: #E5ECF7;
		color: #AAAAAA;
	}
	
	.gp-option-block .el-checkbox__inner {
		width: 20px;
		height: 20px;
	}
	
	.gp-option-block .el-checkbox__inner::after {
	    height: 7px;
	    left: 7px;
	    top: 4px;
	}

	.gp-layer-body {
		min-height: 640px;
		background: #FFFFFF;
		border-radius: 4px;
	}

	.gp-section {
		padding: 20px 50px;
	}

	.gp-row {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.gp-row-label {
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: bold;
		color: #000000;
		line-height: 22px;
	}

	.gp-row-value {
		width: 200px;
	}

	.gp_input {
		width: 100%;
		height: 40px;
	}

	.gp-label-tip {
		margin-top: 10px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
		line-height: 18px;
	}

	.tip1 {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.tip-title {
		margin-top: 10px;
		font-size: 18px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: bold;
		color: #333333;
		line-height: 30px;
	}

	.tip-desc {
		margin-top: 5px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
		line-height: 18px;
	}

	.tip-img {
		margin-top: 9px;
	}

	.tip-img img {
		width: 187px;
		height: 214px;
	}

	.red_require {
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #F56C6C;
		line-height: 12px;
		margin-top: 3px;
		visibility: hidden;
	}

	.gp-option-item {
		padding: 10px;
		background: #F2F6FC;
		border-radius: 2px;
	}

	.gp-option-block {
		display: flex;
		align-items: center;
	}

	.btn-save {
		width: 110px;
		letter-spacing: 1px;
	}

	.margin-top-15 {
		margin-top: 15px;
	}
	.margin-top-30 {
		padding-top: 30px;
	}
	.margin-top-80 {
		margin-top: 80px;
	}
	.margin-left-5 {
		margin-left: 5px;
	}
	.margin-right-12 {
		margin-right: 12px;
	}
	.margin-left-113 {
		margin-left: 113px;
	}
	.margin-left-120 {
		margin-left: 120px;
	}
	.margin-left-190 {
		margin-left: 190px;
	}
	.padding-top-0 {
		padding-top: 0;
	}
	.padding-bottom-0 {
		padding-bottom: 0;
	}
</style>
